module.exports = __webpack_public_path__ + "static/media/HCMM083.e25c7084.jpg";